import { ProductSubCategoryCreatePage } from "@/features/product-sub-category/pages/ProductSubCategoryCreatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/product-sub-category/create")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["product_sub_category.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ProductSubCategoryCreatePage,
});
